module.exports = __webpack_public_path__ + "img/Nutech01.8c086d50.png";